import { render, staticRenderFns } from "./RecentVideosBox.vue?vue&type=template&id=d369d9fa&scoped=true&"
import script from "./RecentVideosBox.vue?vue&type=script&lang=ts&"
export * from "./RecentVideosBox.vue?vue&type=script&lang=ts&"
import style0 from "./RecentVideosBox.vue?vue&type=style&index=0&id=d369d9fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d369d9fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VChipGroup,VDivider,VIcon})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
